import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import api from '../../services/api';
import { hojeBR } from '../../utils/data';
import s from '../../pages/PedidosOrcamentos.module.css';
import InputDataFiltro from '../common/InputDataFiltro';

const fmtMoeda = v => Number(v||0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
const fmtData  = str => { if (!str) return '—'; return new Date(String(str).slice(0,10)+'T12:00:00').toLocaleDateString('pt-BR'); };
const hoje     = () => hojeBR();

const STATUS_LABEL = {
  aberto:    { txt: 'Aberto',    cls: s.badgeAberto    },
  vencido:   { txt: 'Vencido',   cls: s.badgeCancelado },
  recebido:  { txt: 'Recebido',  cls: s.badgeAprovado  },
  cancelado: { txt: 'Cancelado', cls: s.badgeCancelado },
};

const statusEfetivo = (cr) => {
  if (cr.status === 'recebido' || cr.status === 'cancelado') return cr.status;
  if (cr.data_vencimento && cr.data_vencimento < hoje()) return 'vencido';
  return 'aberto';
};

export default function ModalBuscaContaReceber({ onSelect, onClose }) {
  const [filtros, setFiltros] = useState({ busca:'', status:'aberto', venc_de:'2000-01-01', venc_ate:'2099-12-31' });
  const [lista, setLista]     = useState([]);
  const [sel, setSel]         = useState(null);
  const inputRef = useRef(null);

  const buscar = useCallback(async (f) => {
    try {
      const { data } = await api.get('/financeiro/contas-receber', { params: f });
      setLista(data);
    } catch { setLista([]); }
  }, []);

  useEffect(() => { buscar(filtros); setTimeout(() => inputRef.current?.focus(), 60); }, []); // eslint-disable-line

  // Soma do resultado atual — buscando pelo nome de um cliente, já dá o
  // total de débitos dele sem precisar somar linha por linha.
  const totalLista = useMemo(
    () => lista.reduce((s, c) => s + parseFloat(c.valor || 0), 0),
    [lista]
  );

  const set = (k,v) => {
    const nf = {...filtros,[k]:v};
    setFiltros(nf);
    buscar(nf);
  };

  return (
    <div className={s.overlay} onMouseDown={e => e.target===e.currentTarget && onClose()}>
      <div className={s.modal} style={{width:780}}>
        <div className={s.modalTitle}>Buscar Conta a Receber</div>
        <div className={s.modalBody}>
          <div style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:8}}>
            <input ref={inputRef} className={s.inputErp} style={{flex:1,minWidth:200}}
              placeholder="Descrição ou cliente..." value={filtros.busca}
              onChange={e=>set('busca',e.target.value)} />
            <select className={s.selectErp} value={filtros.status} onChange={e=>set('status',e.target.value)}>
              <option value="todos">Todos</option>
              <option value="aberto">Aberto</option>
              <option value="vencido">Vencido</option>
              <option value="recebido">Recebido</option>
              <option value="cancelado">Cancelado</option>
            </select>
            <label style={{fontSize:11,alignSelf:'center'}}>Venc. de</label>
            <InputDataFiltro className={s.inputErp} style={{width:130}} value={filtros.venc_de} onChange={e=>set('venc_de',e.target.value)} />
            <label style={{fontSize:11,alignSelf:'center'}}>até</label>
            <InputDataFiltro className={s.inputErp} style={{width:130}} value={filtros.venc_ate} onChange={e=>set('venc_ate',e.target.value)} />
          </div>
          <div style={{fontSize:12,fontWeight:700,color:'#1565c0',marginBottom:6}}>
            {lista.length} resultado(s) — Total: {fmtMoeda(totalLista)}
          </div>
          <div style={{maxHeight:360,overflowY:'auto'}}>
            <table className={s.modalTabela}>
              <thead><tr>
                <th style={{width:60}}>Cód.</th>
                <th>Descrição</th>
                <th>Cliente</th>
                <th style={{width:90}}>Vencimento</th>
                <th style={{width:100,textAlign:'right'}}>Valor</th>
                <th style={{width:80}}>Status</th>
              </tr></thead>
              <tbody>
                {lista.length===0&&<tr><td colSpan={6} style={{textAlign:'center',color:'#888',padding:12}}>Nenhum resultado.</td></tr>}
                {lista.map(c=>{
                  const st = STATUS_LABEL[statusEfetivo(c)] || STATUS_LABEL.aberto;
                  return (
                    <tr key={c.id} className={sel===c.id?s.linhaAtiva:''} style={{cursor:'pointer'}}
                      onClick={()=>setSel(c.id)} onDoubleClick={()=>onSelect(c)}>
                      <td>{c.id}</td>
                      <td>{c.descricao}</td>
                      <td>{c.cliente_nome||'—'}</td>
                      <td>{fmtData(c.data_vencimento)}</td>
                      <td style={{textAlign:'right'}}>{fmtMoeda(c.valor)}</td>
                      <td><span className={`${s.badge} ${st.cls}`}>{st.txt}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className={s.modalFooter}>
          <button className={`${s.btnErp} ${s.btnErpPrimario}`} disabled={!sel}
            onClick={()=>{ const c=lista.find(x=>x.id===sel); if(c) onSelect(c); }}>Ok</button>
          <button className={s.btnErp} onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
}
